/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, set } from '@ember/object';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import CollectionAttributeCondition from 'cio/app-models/conditions/collection-attribute';
import DeviceAttributeCondition from 'cio/app-models/conditions/device-attribute';
import FormEventAttributeCondition from 'cio/app-models/conditions/form-event-attribute';

interface ComparisonOperatorArgs {
  condition:
    | AttributeCondition
    | EventAttributeCondition
    | CollectionAttributeCondition
    | DeviceAttributeCondition
    | FormEventAttributeCondition;
  disabled?: boolean;
  size?: string;
  variation?: string;
  fluid?: boolean;
  onChange?: (type: 'value' | 'property') => unknown;
}

export default class ArrayConditionType extends Component<ComparisonOperatorArgs> {
  @action
  onChange(type: 'value' | 'property') {
    if (type === 'value') {
      set(this.args.condition, 'name', '');
    }
    set(this.args.condition, 'arrayConditionType', type);

    this.args.onChange?.(type);
  }
}
